<template>
  <div style="display:inline">
    <input type="file" accept="image/*" multiple @change="onFilePicked" ref="fileInput" style="display: none" />
    <v-btn v-if="showUpload" small icon dark fab color="primary" class="mr-3" @click="$refs.fileInput.click()">
      <v-icon>insert_photo</v-icon>
    </v-btn>
    <v-btn small icon dark fab color="accent" @click="prepareCamera">
      <v-icon>photo_camera</v-icon>
    </v-btn>
 
    <!-- Show camera to take photo -->
    <v-dialog v-model="showCamera" max-width="310px">
      <v-card>
        <v-card-text>
          <video id="cam" style="width:280px; height:210px" autoplay></video>
          <slot name="camera-dialog-actions"></slot>
        </v-card-text>
        <div class="text-xs-center pb-3 pt-0">
          <v-btn icon @click="capturePhoto">
            <v-icon x-large>camera</v-icon>
          </v-btn>
        </div>
        <div style="position:absolute; top:15px; right:10px">
          <v-btn small color="grey" icon @click.stop="closeCamDlg">
            <v-icon small>close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
 
<script>
export default {
  name: 'CameraAndFilePicker',
  props: {
    showUpload: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showCamera: false,
      localMediaStream: null
    }
  },
  methods: {
    onFilePicked (e) {
      const files = Array.from(e.target.files)
      if (!files.length) return

      const processedImages = []
      let processedCount = 0

      files.forEach((file, index) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          const img = new Image()
          img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            const MAX_WIDTH = 1280
            const MAX_HEIGHT = 1280
            let width = img.width
            let height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx.drawImage(img, 0, 0, width, height)
            processedImages[index] = canvas.toDataURL('image/jpeg', 0.8)
            processedCount++

            // Emit when all files are processed
            if (processedCount === files.length) {
              this.$emit('upload', processedImages)
              if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
              }
            }
          }
          img.src = event.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    prepareCamera () {
      this.showCamera = true
      this.$emit('camera-opened')
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
        .then(stream => { // success
          document.querySelector('video#cam').srcObject = stream
          this.localMediaStream = stream
        })
        .catch(error => {
          console.error('Webcam access is rejected: ' + error)
        })
    },
    closeCamDlg () {
      this.showCamera = false
      if (this.localMediaStream) {
        var tracks = this.localMediaStream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        this.localMediaStream.srcObject = null
      }
      this.$emit('camera-closed')
    },
    capturePhoto () {
      const video = document.querySelector('video#cam')
      if (!video) return

      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      this.$emit('upload', canvas.toDataURL('image/png'))
      this.closeCamDlg()
    }
  }
}
</script>


// WEBPACK FOOTER //
// CameraAndFilePicker.vue?158865c4